<template>
  <div class="filter-table">
    <el-form inline>
      <el-form-item v-for="item in filterItems" :key="item.name.toString()">
        <el-input v-if="item.type === 'input'" v-model="queryParams[item.name]" v-bind="item.props"
                  :style="{ width: `${item.width || 250}px` }" :placeholder="item.placeholder"
                  :clearable="!item.props || item.props.clearable !== false">
        </el-input>
        <el-select v-if="item.type === 'select'" v-model="queryParams[item.name]" v-bind="item.props"
                   :style="{ width: `${item.width || 120}px` }"  :placeholder="item.placeholder"
                   :clearable="!item.props || item.props.clearable !== false">
          <el-option v-for="option in item.options" :key="option.value"
                     :label="option.label" :value="option.value"></el-option>
        </el-select>
        <el-date-picker v-if="item.type === 'date'" v-bind="item.props" :style="{ width: `${item.width || 240}px` }"
                        :value="arrayValueGet(item.name)"
                        :placeholder="item.placeholder || (item.props && item.props.placeholder) || '选择时间'"
                        :start-placeholder="item.props && item.props.startPlaceholder || '开始时间'"
                        :end-placeholder="item.props && item.props.endPlaceholder || '结束时间'"
                        :type="item.props && item.props.type || (Array.isArray(item.name) ? 'daterange' : 'date')"
                        :value-format="item.props && item.props.valueFormat || 'yyyy-MM-dd'"
                        :clearable="!item.props || item.props.clearable !== false"
                        @input="arrayValueInput(item.name, $event)"
        ></el-date-picker>
        <component v-if="item.type === 'custom'" :is="item.component"
                   :value="arrayValueGet(item.name)"
                   @input="arrayValueInput(item.name, $event)"
        ></component>
      </el-form-item>
      <el-form-item style="margin-right: 0">
        <el-button type="primary" @click="queryData">查询</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="tableData" v-loading="loading">
      <slot></slot>
    </el-table>

    <el-pagination v-if="pagination" background layout="prev, pager, next" :total="totalNum"
                   :current-page.sync="pageNo" :page-size.sync="pageSize" @current-change="queryData">
    </el-pagination>
  </div>
</template>

<script>

export default {
  name: "FilterTable",
  props: {
    filterItems: {
      required: true,
      type: Array,
      default: () => [], // { label: "", name: "searchKey", defaultValue: "1", type: "input", options: [],
      // placeholder: "", width: "", props: {} }
    },
    getApi: {
      required: true,
      type: Function,
    },
    extParams: {
      type: Object,
      default: () => {},
    },
    pagination: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      queryParams: {},
      loading: false,
      tableData: [],
      totalNum: 0,
      pageNo: 1,
      pageSize: 10,
    }
  },
  methods: {
    queryData() {
      this.loading = true;
      const params = { ...this.extParams, ...this.queryParams };
      if (this.pagination) {
        params.pageNo = this.pageNo;
        params.pageSize = this.pageSize;
      }
      this.getApi(params).then(res => {
        if (this.pagination) {
          this.tableData = res.result.list;
          this.totalNum = res.result.totalNum;
        } else {
          this.tableData = res.result;
        }
      }).finally(() => {
        this.loading = false;
      })
    },
    arrayValueGet(itemName) {
      return Array.isArray(itemName) ? itemName.map(name => this.queryParams[name]) : this.queryParams[name];
    },
    arrayValueInput(itemName, value) {
      if (Array.isArray(itemName)) {
        itemName.forEach((name, index) => {
          this.queryParams[name] = value ? value[index] : "";
        });
      } else {
        this.queryParams[name] = value;
      }
    },
  },
  created() {
    let params = {};
    this.filterItems.forEach(item => {
      if (Array.isArray(item.name)) {
        item.name.forEach((name, index) => {
          params[name] = item.defaultValue && item.defaultValue[index] || "";
        })
      } else {
        params[item.name] = item.defaultValue || "";
      }
    });
    this.queryParams = params;
  },
  mounted() {
    this.queryData();
  },
}
</script>

<style lang="scss">
.filter-table {
  .el-form .el-button {
    padding: 10px 24px !important;
  }

  .el-form .el-button--default {
    border: 1px solid #4286F5 !important;
    color: #4286F5 !important;
  }
}
</style>